import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Type } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';

export const CtaSectionCard = ({ settings, updateField }) => {
  const { t } = useLanguage();
  return (
    <Card className="bg-card border-border">
      <CardContent className="p-6">
        <div className="flex items-center gap-2 mb-6">
          <Type className="w-5 h-5 text-primary" />
          <h2 className="text-lg font-bold">{t('siteSettings.ctaSection')}</h2>
        </div>

        <div className="space-y-4">
          <div>
            <Label className="text-sm">{t('siteSettings.ctaTitle')}</Label>
            <Input
              value={settings.cta_title || ''}
              onChange={(e) => updateField('cta_title', e.target.value)}
              className="bg-secondary border-border mt-1"
              data-testid="cta-title"
            />
          </div>
          <div>
            <Label className="text-sm">{t('siteSettings.ctaDescription')}</Label>
            <Input
              value={settings.cta_description || ''}
              onChange={(e) => updateField('cta_description', e.target.value)}
              className="bg-secondary border-border mt-1"
              data-testid="cta-description"
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
